import { useEffect } from 'react';

const useFetchBanners = ({
  adStore,
  bannerPage = null,
  bannerZone = null,
  shouldHaveAds = false,
}) => {
  const getSearchParams = () => ({
    bannerPage,
    bannerZone,
  });

  const loadAds = () => {
    adStore.loadAds(getSearchParams());
  };

  useEffect(() => {
    if (shouldHaveAds) {
      loadAds();
    }
  }, []);
};

export default useFetchBanners;
